export const adaptFrecuenciaDistribuidor = (frecuenciaDistribuidorData) => {


    const loadFrecuenciasCP = (frecuenciaDistribuidorCP) => {
        console.log('loadFrecuenciasCP')

        console.log(frecuenciaDistribuidorCP)
        let listaCP = [];

        frecuenciaDistribuidorCP?.map((cp) => {
            let obj = {
                idFrecuenciaDistribuidor: cp?.idFrecuenciaDistribuidor,
                idFrecuenciaDistribuidorCP: cp?.idFrecuenciaDistribuidorCP,
                idCodigoPostal: cp?.idCodigoPostal,
            }
            listaCP.push(obj)
        });

        return listaCP;
    }
    
    const loadFrecuencias = (frecuenciaDistribuidorDetalle) => {
        const listaDetalle = frecuenciaDistribuidorDetalle.map((detalle) => {
            let listaDias = [];
            detalle?.frecuenciaDistribuidorDetalleDia?.map((dias) => {
                let obj = {
                    idFrecuenciaDistribuidorDetalleDia: dias?.idFrecuenciaDistribuidorDetalleDia,
                    idFrecuenciaDistribuidorDetalle: dias?.idFrecuenciaDistribuidorDetalle,
                    numeroDia: dias?.numeroDia,
                }
                listaDias.push(obj)
            });

            let obj = {
                idFrecuenciaDistribuidorDetalle: detalle?.idFrecuenciaDistribuidorDetalle,
                idFrecuenciaDistribuidor: detalle?.idFrecuenciaDistribuidor,
                horaSalida: detalle?.horaSalidaString,
                demoraHoraDestino: detalle?.demoraHoraDestino,
                metodoCobroBulto: detalle?.metodoCobroBulto,
                metodoCobroKilo: detalle?.metodoCobroKilo,
                metodoCobroKm: detalle?.metodoCobroKm,
                listaFrecuenciaDistribuidorDetalleDias: listaDias
                //frecuenciaDistribuidorDetalleDia: listaDias
            }
            return obj;
        });

        return listaDetalle
    }

    return {
        idFrecuenciaDistribuidor: frecuenciaDistribuidorData?.frecuenciaDistribuidor?.idFrecuenciaDistribuidor,
        idProveedorDistribuidor: frecuenciaDistribuidorData?.frecuenciaDistribuidor?.idProveedorDistribuidor,  
        kilometroDestino: frecuenciaDistribuidorData?.frecuenciaDistribuidor?.kilometroDestino,     
        costoEntregaInmediata: frecuenciaDistribuidorData?.frecuenciaDistribuidor?.costoEntregaInmediata, 
        idDeposito : frecuenciaDistribuidorData?.frecuenciaDistribuidor?.idDeposito,
        activo : frecuenciaDistribuidorData?.frecuenciaDistribuidor?.activo,
        idFrecuenciaModoDespacho: frecuenciaDistribuidorData?.frecuenciaDistribuidor?.idFrecuenciaModoDespacho,
        //distribuidor: frecuenciaDistribuidorData?.idProveedorDistribuidorNavigation?.razonSocial,
        codigoSAP: frecuenciaDistribuidorData?.frecuenciaDistribuidor?.idProveedorDistribuidorNavigation?.codigoSAP,
        codigoPostal: frecuenciaDistribuidorData?.frecuenciaDistribuidor?.frecuenciaDistribuidorCP[0]?.idCodigoPostalNavigation?.cP,
        provincia: frecuenciaDistribuidorData?.frecuenciaDistribuidor?.frecuenciaDistribuidorCP[0]?.idCodigoPostalNavigation?.idProvinciaNavigation?.descripcion,
        localidad: frecuenciaDistribuidorData?.frecuenciaDistribuidor?.frecuenciaDistribuidorCP[0]?.idCodigoPostalNavigation?.localidad,
        idTipoZona: frecuenciaDistribuidorData?.frecuenciaDistribuidor?.frecuenciaDistribuidorCP[0]?.idCodigoPostalNavigation?.idTipoZona,
        rowsFrecuencias: loadFrecuencias(frecuenciaDistribuidorData?.frecuenciaDistribuidorDetalle),
        listaFrecuenciaDistribuidorCPs: loadFrecuenciasCP(frecuenciaDistribuidorData?.frecuenciaDistribuidor?.frecuenciaDistribuidorCP)
    }
}

export const adaptFrecuenciaDistribuidorArray = (
    frecuenciaDistribuidorData
) => {
    return adaptFrecuenciaDistribuidor(frecuenciaDistribuidorData?.frecuenciaDistribuidorById)
}